import { FilterFieldDefinition } from '../../composables/useUrlFilters';
import { UrlFilterSerializer } from '../UrlFilterSerializer';

export const PaymentFilterDefinitions: FilterFieldDefinition[] = [
    {
        key: 'paymentId',
        type: 'text',
        defaultValue: null
    },
    {
        key: 'orderNumber',
        type: 'text',
        defaultValue: null
    },
    {
        key: 'marketplaceCode',
        type: 'dropdown',
        defaultValue: null,
        validate: (value, context) => {
            return context?.marketplaceOptions?.some((opt: any) => opt.code === value) ?? false;
        }
    },
    {
        key: 'paymentType',
        type: 'dropdown',
        defaultValue: null,
        validate: (value, context) => {
            return context?.paymentTypeOptions?.some((opt: any) => opt.value === value) ?? false;
        }
    },
    {
        key: 'balanceType',
        type: 'dropdown',
        defaultValue: null,
        validate: (value, context) => {
            return context?.balanceTypeOptions?.some((opt: any) => opt.value === value) ?? false;
        }
    },
    {
        key: 'description',
        type: 'text',
        defaultValue: null
    },
    {
        key: 'remarks',
        type: 'text',
        defaultValue: null
    },
    {
        key: 'datePaymentOnFrom',
        type: 'date',
        defaultValue: null,
        serialize: UrlFilterSerializer.serializeDate,
        deserialize: UrlFilterSerializer.deserializeDate
    },
    {
        key: 'datePaymentOnTo',
        type: 'date',
        defaultValue: null,
        serialize: UrlFilterSerializer.serializeDate,
        deserialize: UrlFilterSerializer.deserializeDate
    }
];
